import { ActionControlSize } from "@1js/acui-common";

import { RibbonControlProps } from "../../Controls/RibbonControlProps";
import { getIconBasedOnSize } from "../../ribbonIconSet";

export function getRibbonGroupItemsIcon(
  props: RibbonControlProps,
  size?: ActionControlSize
) {
  switch (props.type) {
    case "AppButtonProps":
    case "AppInkButtonProps":
    case "AppComboBoxProps":
    case "AppToggleButtonProps":
    case "AppFlyoutAnchorProps":
    case "AppInkFlyoutAnchorProps":
    case "AppSplitButtonProps":
    case "AppSpinButtonProps":
    case "AppLabelProps":
      return getIconBasedOnSize(props.iconSet, size);
  }

  return undefined;
}
